<template>
    <div class="position-relative">
        <label v-if="label"
               :for="id" class="form-label" :class="[$attrs.required !== undefined ? 'required' : '', light ? 'text-white' : '']">{{ label }}</label>

        <div class="input-group">
          <select
                 :id="id"
                 :value="modelValue"
                 class="form-select"
                 :class="[hasError() ? 'is-invalid' : '']"
                 @input="$emit('update:modelValue', $event.target.value)"
                 v-bind="$attrs"
          >
              <option :value="''" :disabled="true" style="display:none;">{{$t('common.pleaseChoose')}}</option>
              <slot />
          </select>
          <button v-if="reset" class="btn btn-outline-danger" :disabled="!value" type="button" @click="emptyValue()"><i class="fa-solid fa-xmark"></i></button>
        </div>
        <div v-if="hasError()" class="invalid-feedback">
            <ul class="inputError">
                <li v-for="(error, index) in errors[this.name]" :key="index">{{error}}</li>
            </ul>
        </div>
    </div>
</template>

<script>

import {generateUUID} from "@/helper";
export default {
    name: "selectField",
    emits: ['update:modelValue'],
    props: {
        modelValue: {},
        id:{
            type: String,
            default(){
                return generateUUID();
            }
        },
        name: {
            type: String,
            required: true,
        },
        errors: {
            type: Object,
            default() {
                return {};
            }
        },
        label: {
          type: String,
        },
        light:{
          type: Boolean,
          default: false,
        },
        reset:{
          type: Boolean,
          default: false,
        }
    },
    computed: {
        value() {
            if(typeof this.modelValue === undefined) {
                return 3;
            }

            if(this.modelValue === null) {
                return null;
            }

            return this.modelValue;
        }
    },
    methods: {
        hasError() {
          return this.errors[this.name] !== undefined;
        },
        emptyValue(){
          this.$emit('update:modelValue', '');
        }
    }
}
</script>

<style scoped>

</style>